import { createSelector } from 'reselect';

export const filterEventsByCalendarDisplay = createSelector(
  Events => Events,
  (_, { includeMonthView, includeWeekView, includeDayView }) => ({
    includeMonthView,
    includeWeekView,
    includeDayView,
  }),
  (_, __, calendarMap) => calendarMap,
  (Events, { includeMonthView, includeWeekView, includeDayView }, calendarMap) => {
    // Validate the inputs
    if (!Events || typeof Events !== 'object') return {};
    if (!calendarMap || typeof calendarMap !== 'object') return {};

    // Function to check if an event should be included based on display options and calendar settings
    const shouldIncludeEvent = event => {
      const eventCalendar = calendarMap[event.calendar_id];
      if (!eventCalendar) return false;

      // Override individual event settings if calendar settings dictate otherwise
      if (!includeMonthView && event.display_month_view) return true;
      if (!includeWeekView && event.display_week_view) return true;
      if (!includeDayView && event.display_day_view) return true;

      // Check event's display settings
      if (!includeMonthView && event.display_month_view === 0) return false;
      if (!includeWeekView && event.display_week_view === 0) return false;
      if (!includeDayView && event.display_day_view === 0) return false;

      // Check calendar's display settings
      if (!includeMonthView && !eventCalendar.display_month_view) return false;
      if (!includeWeekView && !eventCalendar.display_week_view) return false;
      if (!includeDayView && !eventCalendar.display_day_view) return false;

      return true;
    };

    // Filter events while maintaining the original structure
    const filteredEvents = Object.entries(Events).reduce((acc, [key, eventList]) => {
      if (Array.isArray(eventList)) {
        const filteredList = eventList.filter(shouldIncludeEvent);
        if (filteredList.length > 0) {
          acc[key] = filteredList;
        }
      }
      return acc;
    }, {});

    return filteredEvents;
  }
);
